import classNames from 'classnames';
import React, { forwardRef, } from 'react';
import { isNumber } from '@/utils/func';
import { defaultTextRender, progressBackgroundColor, progressiveColor, progressSize, statusColor, } from './utils';
const LinearProgress = (props, ref) => {
    const { prefix = 'cn-ui-m-', percent = 0, color, size = 'medium', backgroundColor, progressive = false, state = 'normal', textRender = defaultTextRender, hasBorder, className, rtl, ...others } = props;
    const progressiveColorEnabled = () => {
        if (progressive) {
            return progressiveColor(percent);
        }
        else {
            return color || statusColor(state);
        }
    };
    const trackStyle = {
        height: progressSize(size),
        backgroundColor: progressBackgroundColor(backgroundColor),
    };
    const barStyle = {
        height: progressSize(size),
        backgroundColor: progressiveColorEnabled(),
        width: `${percent}%`,
    };
    if (isNumber(size) && size > 0) {
        const borderRadiusVal = `${size / 2}rpx`;
        trackStyle.borderRadius = borderRadiusVal;
        barStyle.borderRadius = borderRadiusVal;
    }
    const clsPrefix = `${prefix}progress`;
    const text = textRender(percent, { rtl });
    return (React.createElement("div", { ref: ref, ...others, className: classNames(clsPrefix, `${clsPrefix}-line--${size}`, `${clsPrefix}-line-${size}-corner`, className) },
        React.createElement("div", { className: classNames(`${clsPrefix}-track`, `${clsPrefix}-line-${size}-corner`, {
                [`${clsPrefix}-line-show-border`]: hasBorder,
            }), style: trackStyle },
            React.createElement("div", { className: classNames(`${clsPrefix}-line-bar`, `${clsPrefix}-line-${size}-corner`), style: barStyle })),
        text !== '' && text !== undefined && text !== null ? (React.createElement("div", { className: `${clsPrefix}-line-text` }, text)) : null));
};
export default forwardRef(LinearProgress);
